import moment from 'moment';

/**
 * Normalizes user role string to lowercase trimmed string
 */
export const getNormalizedRole = (role) => {
  if (!role || typeof role !== 'string') return '';
  return role.trim().toLowerCase();
};

/**
 * Checks if the role is Super Admin
 */
export const isSuperAdmin = (role) => {
  const r = getNormalizedRole(role);
  return r === 'super admin' || r === 'superadmin';
};

/**
 * Checks if the role is Admin
 */
export const isAdmin = (role) => {
  const r = getNormalizedRole(role);
  return r === 'admin';
};

/**
 * Checks if the role is Limited Admin
 */
export const isLimitedAdmin = (role) => {
  const r = getNormalizedRole(role);
  return r === 'limited admin' || r === 'limitedadmin';
};

/**
 * Checks if a given date string matches today's local date
 * Handles YYYY-MM-DD, ISO timestamps, and moment-parseable dates
 */
export const isEditableToday = (dateVal) => {
  if (!dateVal || dateVal === '-') return false;
  const mDate = moment(dateVal);
  if (!mDate.isValid()) return false;
  return mDate.isSame(moment(), 'day');
};
